import { PopupRequest } from '@azure/msal-browser';
import { envConfiguration } from 'src/utils/loadEnvConfig';

export const loginRequest: PopupRequest = {
  scopes: [`${envConfiguration.clientId}/.default`],
};
